module.exports = __webpack_public_path__ + "img/194.e412d987.jpg";